/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {WorkflowPageOf, WorkflowPageOfFromJSON, WorkflowPageOfToJSON,} from './WorkflowPageOf';

/**
 *
 * @export
 * @interface WorkflowPageOfApiResult
 */
export interface WorkflowPageOfApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowPageOfApiResult
     */
    success?: boolean;
    /**
     *
     * @type {WorkflowPageOf}
     * @memberof WorkflowPageOfApiResult
     */
    content?: WorkflowPageOf;
    /**
     *
     * @type {string}
     * @memberof WorkflowPageOfApiResult
     */
    message?: string | null;
}

export function WorkflowPageOfApiResultFromJSON(json: any): WorkflowPageOfApiResult {
    return WorkflowPageOfApiResultFromJSONTyped(json, false);
}

export function WorkflowPageOfApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowPageOfApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : WorkflowPageOfFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowPageOfApiResultToJSON(value?: WorkflowPageOfApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': WorkflowPageOfToJSON(value.content),
        'message': value.message,
    };
}

